import { render } from "./ExternalSearchRequestInfo.vue?vue&type=template&id=2ff842fc&ts=true"
import script from "./ExternalSearchRequestInfo.vue?vue&type=script&lang=ts"
export * from "./ExternalSearchRequestInfo.vue?vue&type=script&lang=ts"

import "./ExternalSearchRequestInfo.vue?vue&type=style&index=0&id=2ff842fc&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__